/**
 * Joins multiple URL path segments together.
 *
 * @param segments - Array of path segments to join.
 * @returns The joined path string.
 *
 * @example
 * ```typescript
 * joinPaths(["api", "users", "123"]) // "/api/users/123"
 * joinPaths(["", "api", "users"])    // "/api/users"
 * ```
 */
export function joinPaths(segments: (string | null | undefined)[]): string {
  const joined = segments
    .filter((s): s is string => Boolean(s))
    .map((s) => s.replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/")

  return `/${joined}`
}
